import { ContentSection, DividerList, LabeledListItem } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { ProductPricing } from '@mews-commander/data-access';
import { WithProductId } from '@mews-commander/types';
import { UnicodeEntity } from '@mews/enums';
import { useProductQuery } from '../../../queries/useProductQuery';
import { useTaxExemptionReasons } from '../../../hooks/useTaxExemptionReasons';
import { AbsolutePricingSection } from './AbsolutePricingSection';
import { RelativePricingSection } from './RelativePricingSection';
import { ChargingSection } from './ChargingSection';
import { TaxationList } from './TaxationList';

export const PricingTabContent = ({ productId }: WithProductId) => {
    const {
        chargingMode,
        pricing,
        postingMode,
        consumptionMoment,
        taxExemptionReasonCode,
        taxExemptionLegalReference,
    } = useProductQuery({ productId });
    const taxExemptionReasons = useTaxExemptionReasons();

    const taxRateCodes =
        (pricing.discriminator === ProductPricing.Absolute
            ? pricing.value.taxValues?.map(({ taxRateCode }) => taxRateCode)
            : pricing.value.taxRateCodes) || [];

    return (
        <Stack spacing="400" vertical>
            <ContentSection title={lt('Pricing')}>
                {pricing.discriminator === ProductPricing.Absolute ? (
                    <AbsolutePricingSection pricing={pricing.value} />
                ) : (
                    <RelativePricingSection pricing={pricing.value} />
                )}
            </ContentSection>
            <ContentSection title={lt('Tax')}>
                <DividerList>
                    <TaxationList taxRateCodes={taxRateCodes} />
                    <LabeledListItem label={lt('TaxExemptionReason')}>
                        {taxExemptionReasonCode && taxExemptionReasons[taxExemptionReasonCode]?.name
                            ? taxExemptionReasons[taxExemptionReasonCode].name
                            : UnicodeEntity.Dash}
                    </LabeledListItem>
                    <LabeledListItem label={lt('LegalReference')}>
                        {taxExemptionLegalReference ?? UnicodeEntity.Dash}
                    </LabeledListItem>
                </DividerList>
            </ContentSection>
            <ChargingSection
                charging={pricing.discriminator === ProductPricing.Absolute ? chargingMode : postingMode}
                consumptionMoment={consumptionMoment}
            />
        </Stack>
    );
};
